import { SimpleTree } from "app/common/components/SimpleTree"
import { upsertFilter } from "app/common/utilities/search"
import { unflattenFacetResults } from "app/common/utilities/tree"
import { BrandSearchFilter } from "app/search/codecs"
import { FacetMap } from "app/search/codecs/map"
import { Link } from "blitz"
import { array, option, record } from "fp-ts"
import { pipe } from "fp-ts/function"
import useTranslation from "next-translate/useTranslation"
import { FC } from "react"
import { tw } from "twind"
import { css } from "twind/css"

interface FilterSelectorProps {
  createUrl: (filters: BrandSearchFilter[]) => string
  facetMap: FacetMap
  filters: BrandSearchFilter[]
}

export const FilterSelector: FC<FilterSelectorProps> = ({ createUrl, facetMap, filters }) => {
  const { t } = useTranslation("common")

  return (
    <nav>
      <ul className={tw(`flex(& col 1) gap-6`)}>
        {pipe(
          facetMap,
          record.keys,
          array.map((facetKey) =>
            pipe(facetMap[facetKey], unflattenFacetResults, (tree) => {
              const activeKeyPath = pipe(
                filters,
                array.findFirst((filter) => filter.field === facetKey),
                option.map((filter) => filter.value)
              )

              return array.isNonEmpty(tree) ? (
                <li key={facetKey}>
                  <span
                    className={tw(
                      `mb-3`,
                      `inline-block`,
                      `px-3 py-1`,
                      `font-semibold`,
                      css`
                        border: 2px solid #ddd;
                      `
                    )}
                  >
                    {t(facetKey)}
                  </span>

                  <div className={tw(`ml-6`, `text-sm`)}>
                    <SimpleTree
                      activeKey={activeKeyPath as option.Option<string>}
                      getChildren={(facetNode) => facetNode.children}
                      getKey={(facetNode) => facetNode.value}
                      getLabel={(facetNode) => (
                        <Link
                          href={pipe(
                            filters,
                            upsertFilter({ field: facetKey, value: facetNode.value }),
                            createUrl
                          )}
                        >
                          <a className={tw(`blogLink`, `whitespace-nowrap`)}>
                            {facetNode.name}{" "}
                            <span className={tw(`text(xs gray-500)`)}>({facetNode.count})</span>
                          </a>
                        </Link>
                      )}
                      items={tree}
                    />
                  </div>
                </li>
              ) : null
            })
          )
        )}
      </ul>
    </nav>
  )
}
